import CryptoJS from "crypto-js";

const SECRET_KEY = "ROLE_SECRET_2026_XYZ";

// ======================
// 🔐 ENCRYPT ROLE
// ======================
export const encryptRole = (role) => {
  return CryptoJS.AES.encrypt(role, SECRET_KEY).toString();
};

// ======================
// 🔓 DECRYPT ROLE
// ======================
export const decryptRole = (encryptedRole) => {
  if (!encryptedRole) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedRole, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return decrypted || null;
  } catch (err) {
    return null;
  }
};

// ======================
// 💾 SAVE ROLE
// ======================
export const setUserRole = (role) => {
  const encrypted = encryptRole(role);
  localStorage.setItem("userRole", encrypted);
};

// ======================
// 📥 GET ROLE
// ======================
export const getUserRole = () => {
  const encrypted = localStorage.getItem("userRole");
  return decryptRole(encrypted);
};

// ======================
// ❌ REMOVE ROLE
// ======================
export const removeUserRole = () => {
  localStorage.removeItem("userRole");
};